function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { ANALYTICS_KEY } from '../../constants.js';
import { AnalyticsProvider } from '../../providers/AnalyticsProvider.js';
import '../Div/index.js';
import { Facebook } from './icons/Facebook.js';
import { LinkChain } from './icons/LinkChain.js';
import { Linkedin } from './icons/Linkedin.js';
import { Twitter } from './icons/Twitter.js';
import { SvgLink } from './SvgLink.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Div } from '../Div/Div.js';
function ShareLinks({
  canonicalUrl
}) {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    copySuccess = _useState2[0],
    setCopySuccess = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    documentTitle = _useState4[0],
    setDocumentTitle = _useState4[1];
  const copyUrl = async url => {
    await navigator.clipboard.writeText(url);
    const text = await navigator.clipboard.readText();
    text && setCopySuccess(true);
    setTimeout(() => {
      setCopySuccess(false);
    }, 500);
  };
  useEffect(() => {
    setDocumentTitle(encodeURIComponent(document?.title));
  }, []);
  return /*#__PURE__*/jsx(Div, {
    position: "relative",
    flexDirection: "column",
    children: /*#__PURE__*/jsxs(Div, {
      gap: 1,
      children: [/*#__PURE__*/jsx(AnalyticsProvider, {
        analyticsPrefix: ANALYTICS_KEY.Twitter,
        children: /*#__PURE__*/jsx(SvgLink, {
          link: `https://twitter.com/intent/tweet?text=${documentTitle}&url=${canonicalUrl}`,
          svg: /*#__PURE__*/jsx(Twitter, {
            fill: "var(--primary)"
          })
        })
      }), /*#__PURE__*/jsx(AnalyticsProvider, {
        analyticsPrefix: ANALYTICS_KEY.Facebook,
        children: /*#__PURE__*/jsx(SvgLink, {
          link: `https://www.facebook.com/share.php?u=${canonicalUrl}`,
          svg: /*#__PURE__*/jsx(Facebook, {
            fill: "var(--primary)"
          })
        })
      }), /*#__PURE__*/jsx(AnalyticsProvider, {
        analyticsPrefix: ANALYTICS_KEY.LinkedIn,
        children: /*#__PURE__*/jsx(SvgLink, {
          link: `https://linkedin.com/sharing/share-offsite/?url=${canonicalUrl}`,
          svg: /*#__PURE__*/jsx(Linkedin, {
            fill: "var(--primary)"
          })
        })
      }), /*#__PURE__*/jsx(AnalyticsProvider, {
        analyticsPrefix: ANALYTICS_KEY.LinkChain,
        children: /*#__PURE__*/jsx(SvgLink
        // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
        , {
          onClick: () => {
            copyUrl(canonicalUrl);
          },
          svg: /*#__PURE__*/jsx(LinkChain, {
            fill: copySuccess ? 'var(--positive-foreground)' : 'var(--primary)'
          }),
          background: copySuccess ? 'positive' : undefined
        })
      })]
    })
  });
}
export { ShareLinks };
//# sourceMappingURL=ShareLinks.js.map
